var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "container",
    staticClass: "chatter"
  }, [_vm._l(_vm.messageList, function (data, index) {
    return _vm.playState ? _c(data.type, {
      key: index,
      tag: "component",
      attrs: {
        "data": data
      },
      on: {
        "scrollToEnd": _vm.scrollToEndHandler,
        "opencard": _vm.openCardHandler,
        "subscribe": _vm.subscribeHandler
      }
    }) : _vm._e();
  }), _vm._v(" "), !_vm.playState ? _c('live-completed') : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };